import classNames from "classnames";
import React from "react";

function Spinner({ dark }) {
  return (
    <div className="ml-2 flex items-center justify-center">
      <div
        className={classNames(
          "animate-spin rounded-full h-4 w-4 border-t-2 border-b-2 border-white-900",
          { "border-gray-900": dark }
        )}
      ></div>
    </div>
  );
}

export default Spinner;
